import React from "react";
import ReactDOM from "react-dom/client";
import { Link } from "react-router-dom";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./pages/ScrollToTop";

import HomePage from "./pages/HomePage.jsx";
import LayoutPage from "./pages/LayoutPage.jsx";
import GalleryPage from "./pages/GalleryPage.jsx";
import RedirectPage from "./pages/RedirectPage.jsx";

import TestAPI from "./pages/TestAPI.jsx";
import apiClient from "./axiosWrapper";

window.apiClient = apiClient;

function NotFoundPage() {
    return (
        <div className="flex flex-col items-center justify-center h-screen bg-[#e3f3ff] text-[#00477d]">
            <h1 className="mb-4 text-9xl font-bold">404</h1>
            <p className="mb-8 text-3xl">Oops! Page not found</p>
            <div className="animate-bounce w-16 h-16 rounded-full bg-[#00477d] mb-8 flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-white">  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" /></svg>
            </div>
            <p className="mb-4 text-xl">
                The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
            </p>
            <Link
                to="/"
                className="bg-[#00477d] hover:bg-[#00477d]/80 text-white font-bold py-3 px-6 rounded-full transition-all duration-300"
            >
                Go Back Home
            </Link>
            <style>
                {`
                  body { background-color: #e3f3ff; }
                `}
            </style>
        </div>
    );
}

function App() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/article" element={<LayoutPage />} />
                <Route path="/team" element={<LayoutPage type="proker" />} />
                <Route path="/extra" element={<LayoutPage type="extra" />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/comment-policy" element={<LayoutPage type="commentPolicy" />} />
                <Route path="/article/:encryptedId" element={<LayoutPage type="articleDetail" />} />
                <Route path="/team/:encryptedId" element={<LayoutPage type="prokerDetail" />} />
                <Route path="/extra/:encryptedId" element={<LayoutPage type="extraDetail" />} />
                <Route path="/gallery/:encryptedId" element={<GalleryPage type="albumDetail" />} />
                <Route path="/redirect/:type/:id" element={<RedirectPage />} />
                <Route path="/test-api/" element={<TestAPI />} />

                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </Router>
    );
}

const rootElement = document.querySelector("#app");
const root = ReactDOM.createRoot(rootElement);
root.render(<App />);
